import React from 'react';
import { Grid, Icon, Button } from 'e100-react-components';
import useStyles from './useStyles';
import { useMediaQuery } from 'common/hooks';
import { useMyFleetOperations } from '../../SearchCarMyFleet';
import { useIntl } from 'react-intl';

export const Title = () => {
  const { isMobile } = useMediaQuery();
  const classes = useStyles();
  const { resetSelectCar } = useMyFleetOperations();
  const { formatMessage } = useIntl();

  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      justify="space-between"
    >
      <Button
        variant="text"
        color="secondary"
        classes={{
          root: classes.button
        }}
        size={'small'}
        {
          ...!isMobile && ({
            startIcon: (
              <Icon kind="arrowBack" classes={{ root: classes.buttonIcon }} />
            )
          })
        }
        onClick={resetSelectCar}
        id="back-to-route-form"
      >
        {formatMessage({ id: 'back' })}
      </Button>
    </Grid>
  );
};
